import * as _ from 'lodash'
import isArray from 'lodash/isArray'
import isEmpty from 'lodash/isEmpty'
import { getJWTPayload } from '.'

const iamAdminRoles = {
  810: 'TECD Administrator',
}

const iamUserRoles = {
  809: 'TECD User',
}

const roles = {
  ...iamAdminRoles,
  ...iamUserRoles,
}

const getRoleOrg = (roleOrgPairs: any) => {
  const { VITE_NODE_ENV } = import.meta.env
  if (isEmpty(roleOrgPairs) || !isArray(roleOrgPairs)) {
    return null
  }

  const matchedRoleOrgs = roleOrgPairs.filter((item) => {
    // Check role id
    let isValidRole = false
    for (let roleId in roles) {
      if (roleId === item.rid) {
        isValidRole = true
        break
      }
    }
    return isValidRole
  })

  if (isEmpty(matchedRoleOrgs)) {
    return null
  }

  if (matchedRoleOrgs.length > 1 && VITE_NODE_ENV !== 'production') {
    console.info(
      'The given EPL account has multiple roles',
      JSON.stringify(matchedRoleOrgs, null, 2)
    )
  }

  return matchedRoleOrgs[0]
}

const getRoleOrgList = () => {
  const jwtPayload = getJWTPayload()
  const roleOrgPairs = _.get(jwtPayload, 'cb.ro')

  if (_.isEmpty(roleOrgPairs) || !_.isArray(roleOrgPairs)) {
    return null
  }

  const matchedRoleOrgs = roleOrgPairs.filter((item) => {
    // Check role id
    let isValidRole = false
    for (let roleId in roles) {
      if (roleId === item.rid) {
        isValidRole = true
        break
      }
    }
    return isValidRole
  })

  if (_.isEmpty(matchedRoleOrgs)) {
    return null
  }

  if (matchedRoleOrgs.length > 1 && process.env.NODE_ENV !== 'production') {
    console.info(
      'The given EPL account has multiple roles',
      JSON.stringify(matchedRoleOrgs, null, 2)
    )
  }

  // remove all duplicate roles within an institution.
  // Duplicated means a user has both an admin and 'user' role for the same org id.
  const nonDuplicatedRoles = dedupRoles(matchedRoleOrgs)
  return nonDuplicatedRoles
}

const dedupRoles = (roles) => {
  const finalRoles: Array<any> = []
  // group all roles for this user by the org id
  const groupedByOrgId = _.groupBy(roles, 'oid')
  Object.values(groupedByOrgId).forEach((orgIdRoles: any) => {
    if (orgIdRoles.length > 1) {
      // if there is more than 1 role PER INST
      // only add the admin role
      const adminRole = _.find(orgIdRoles, (role) => role.rid === '810')
      if (adminRole) {
        finalRoles.push(adminRole)
      }
    } else {
      // there is only 1 role for this inst, add it
      finalRoles.push(...orgIdRoles)
    }
  })
  return finalRoles
}

export { getRoleOrg, getRoleOrgList }
